export enum RiskObservationSource {
    Manual = 1,
    Meeting = 2,
    Audit = 3,
    ThreatIntelligence = 4,
    Incident = 5,
}

export interface RiskObservationSaveModel {
    id: string;
    name: string;
    description?: string;
    source: RiskObservationSource;
    observedBy: string;
    // Null while the date picker has been cleared; validated as required on save.
    observedDate: Date | null;
}
